import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType } from '@devwareapps/devware-cap';


@DwComponent({
  key: 'nutrient-pdf-viewer',
  name: 'Nutrient PDF Viewer',
  componentType: DwComponentType.pageComponent,
  isGlobal: true,
  //parentItemName: [ AppMetaDataItemNames.ProcessorConfig ]
})
@Component({
  selector: 'app-nutrient-pdf-viewer',
  templateUrl: './nutrient-pdf-viewer.component.html',
  styleUrls: ['./nutrient-pdf-viewer.component.scss']
})
export class NutrientPdfViewerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.setupNutrientViewer();
    //  NutrientViewer.load({
    //   // Use the assets directory URL as a base URL. Nutrient will download its library assets from here.
    //   baseUrl: `${location.protocol}//${location.host}/assets/`,
    //   document: "/assets/document.pdf",
    //   container: "#nutrient-container",
    // }).then(instance => {
    //   // For the sake of this demo, store the Nutrient for Web instance
    //   // on the global object so that you can open the dev tools and
    //   // play with the Nutrient API.
    //   (window as any).instance = instance;
    // });
  }

  setupNutrientViewer() {
    //const container = document.querySelector(".container") as HTMLElement;

    const container = document.getElementById("pspdfkit-container") as HTMLElement;

    const { NutrientViewer } = window as any; 

    // Ensure there's only one `NutrientViewer` instance.
    NutrientViewer?.unload(container);

    let pdf = "https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/faa-h-8083-25c.pdf";

    pdf = "https://www.nutrient.io/downloads/nutrient-web-demo.pdf";

    pdf = "/assets/faa-h-8083-25c.pdf";
   // pdf = "https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/faa-h-8083-25c.pdf";
    if (container && NutrientViewer) {
      
      NutrientViewer.load({
        container,
        document: pdf,
      })
        .then((instance) => {
          console.log("Nutrient loaded", instance);
        })
        .catch(console.error);
    }
  }

}
